/* Score band and row status → the kit's badge tones. No JSX, on purpose.
 *
 * These two live beside the components rather than inside `cells.tsx` because a module that exports
 * both a component and a constant defeats fast refresh — but the real reason they are shared at all
 * is that a bar, a badge, a strip cell and a figure all have to agree about what "good" looks like.
 * `scoreBand` mirrors `ScoreBar`'s own thresholds, so the agreement reaches the shared kit too.
 */

import type { BadgeTone } from '@/shared/ui/StatusBadge';

import { scoreBand } from '../model/presentation';
import type { ScoreStatus } from '../model/types';

/** `unknown` for an absent score, never `danger`: "we did not measure" is not "it failed". */
export function bandTone(value: number | null): BadgeTone {
  if (value === null) return 'unknown';
  const band = scoreBand(value);
  return band === 'ok' ? 'ok' : band === 'warn' ? 'warn' : 'danger';
}

/** Total over `ScoreStatus`, so a fifth status is a compile error rather than a row that silently
 * paints itself with whatever the default branch happened to be. */
export const STATUS_TONE: Readonly<Record<ScoreStatus, BadgeTone>> = {
  healthy: 'ok',
  warning: 'warn',
  critical: 'danger',
  unscored: 'unknown',
};
